import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Spinner } from '@shared/models/spinner';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SecurityService } from '@core/services/security.service';
import { paths } from '@env/paths';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  spinnerObject!: Spinner;
  constructor(
    private readonly securityService: SecurityService,
    private readonly router: Router
  ) {
    this.spinnerObject = {
      loadingTitle: 'global.loading-spinner-auth-title',
      loadingSubtitle: 'global.loading-spinner-auth-subtitle',
      isLoading: false,
    };
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    const hostname = window?.location?.hostname;
    if (hostname !== 'localhost') {
      if (err.status === 401 || err.status === 403) {
        // If user had a token but got 401/403, their access likely expired
        // Redirect to forbidden page instead of SSO to avoid infinite loop
        this.router.navigate([paths.common.forbidden], { queryParams: { reason: 'expired' } });
      }
    }
    return throwError(() => err);
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const authReq = req.clone();
    return next
      .handle(authReq)
      .pipe(catchError((error) => this.handleAuthError(error)));      
  }
}
